import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../services/authentication/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({ selector: '[appHasRole]' })
export class HasRoleDirective implements OnInit, OnDestroy {
  @Input('appHasRole') roles: string[];
  private destroy$ = new Subject<void>();
  private hasView = false;

  constructor(
    private auth: AuthService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    this.auth.userData
      .pipe(takeUntil(this.destroy$))
      .subscribe(userData => {
        // Check if user has any of the required roles
        const hasRole = userData && this.roles?.length && this.roles.some(role =>
          userData.appRoles?.includes(role.toLowerCase()) ||
          userData.role?.toLowerCase() === role.toLowerCase()
        );

        if (hasRole && !this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
        } else if (!hasRole && this.hasView) {
          this.viewContainer.clear();
          this.hasView = false;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
